import { render, staticRenderFns } from "./src/components/home.html?vue&type=template&id=79986b06&scoped=true&"
import script from "./src/components/home.js?vue&type=script&lang=js&"
export * from "./src/components/home.js?vue&type=script&lang=js&"
import style0 from "./src/components/home.scss?vue&type=style&index=0&id=79986b06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79986b06",
  null
  
)

export default component.exports